/* =============================================================
   ENVIRONMENT
   =============================================================
   The single place that reads `import.meta.env`, mirroring
   `.env.example`.

   Unlike the main app, there is no "not configured yet" branch
   and no local stand-in to fall back to: an admin panel that
   pretends to have a backend is worse than one that refuses to
   start, because every screen in it is a write screen.
   ============================================================= */

function str(value: unknown, fallback = ''): string {
  return typeof value === 'string' && value.trim() !== '' ? value.trim() : fallback
}

export const env = {
  mode: import.meta.env.MODE,
  isDev: import.meta.env.DEV,

  supabaseUrl: str(import.meta.env.VITE_SUPABASE_URL),
  supabaseAnonKey: str(import.meta.env.VITE_SUPABASE_ANON_KEY),
} as const

export const isSupabaseConfigured = Boolean(env.supabaseUrl && env.supabaseAnonKey)
